'use client'
import { clsx } from 'clsx'

import { FC } from 'react'

import { Maybe } from '@/app/graphql/generated'
import { BtnCallComponent } from '@/app/shared/components/btn-call'
import {
  getColorBgSite,
  getColorBorderSite,
  getColorBtnSite,
  getColorHoverBgSite,
  getColorTextSite,
} from '@/app/shared/components/modals/modal/services'
import { SiteInfoComponent } from '@/app/shared/components/site-info'
import useScrollToBlock from '@/app/shared/hooks/useScrollToBlock'
import { IconCLose } from '@/app/shared/icons'
import useLayout from '@/app/shared/store/layout.store'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { LogoComponent } from '@/app/shared/ui/logo'

// interface
interface IBurgerMenu {
  close: () => void
}

// component
const BurgerMenuComponent: FC<Readonly<IBurgerMenu>> = ({ close }) => {
  const { scrollToSection } = useScrollToBlock()

  const pages = useLayout((state) => state.pages)
  const typeSite = useLayout((state) => state.typeSite)
  const closeModal = useModal((state) => state.closeAll)

  const handleNavClick = (anchor: Maybe<string> | undefined) => {
    closeModal()
    scrollToSection(anchor)
  }

  // return
  return (
    <div className={'overflow grid gap-[50px] tablet:w-[622px]'}>
      <LogoComponent
        className={'laptop:hidden'}
        classIcon={getColorTextSite(typeSite)}
        typeSite={typeSite}
      />
      <ButtonComponent
        className={clsx(
          'absolute right-[19px] top-[23px] hidden h-[34px] min-h-0 w-[34px] min-w-0 items-center justify-center rounded-full border-2 border-content1-400 p-0 text-primary laptop:flex',
          getColorBgSite(typeSite),
        )}
        onClick={() => close()}
      >
        <IconCLose className={'h-[80%] w-[80%]'} />
      </ButtonComponent>
      <div>
        <ul className={clsx('grid border-t-2', getColorBorderSite(typeSite))}>
          {pages?.slice(1)?.map((el, index) => (
            <li
              key={index}
              className={clsx(
                'flex h-auto cursor-pointer items-center border-b-2 p-[10px] text-2xl font-extrabold transition-background',
                getColorHoverBgSite(typeSite),
                getColorBorderSite(typeSite),
              )}
            >
              <button
                type={'button'}
                onClick={() => handleNavClick(el?.type)}
                className={'h-full w-full text-left'}
              >
                {el?.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {/*<div*/}
      {/*  className={clsx(*/}
      {/*    'flex flex-col text-[14px] font-semibold extraMobile:flex-row laptop:hidden',*/}
      {/*    getColorTextSite(typeSite),*/}
      {/*  )}*/}
      {/*>*/}
      {/*  <span className={'mr-5'}>Графік роботи:</span>*/}
      {/*  <div className={'flex'}>*/}
      {/*    {schedule.map((el, index) => (*/}
      {/*      <span key={index} className={'mr-2.5'}>*/}
      {/*        {el?.value}*/}
      {/*      </span>*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className={'flex flex-wrap items-start extraMobile:flex-nowrap'}>
        {/*<ul className={'mb-3 mr-[27px] grid gap-2.5 text-[22px] extraMobile:mb-0 laptop:hidden'}>*/}
        {/*  {phones.map((item, index: number) => (*/}
        {/*    <li key={index}>*/}
        {/*      <Link*/}
        {/*        href={`tel:${item?.value?.replace(/\D/g, '')}`}*/}
        {/*        className={*/}
        {/*          'whitespace-nowrap font-semibold outline-0 transition hover:text-secondary'*/}
        {/*        }*/}
        {/*      >*/}
        {/*        {item?.value}*/}
        {/*      </Link>*/}
        {/*    </li>*/}
        {/*  ))}*/}
        {/*</ul>*/}
        <SiteInfoComponent
          classNameIcon={getColorTextSite(typeSite)}
          className={'laptop:flex'}
          modal
        />
      </div>
      <BtnCallComponent
        colorType={getColorBtnSite(typeSite)}
        className={'w-full'}
        callback={close}
      />
    </div>
  )
}

BurgerMenuComponent.displayName = 'BurgerMenuComponent'

export default BurgerMenuComponent
